export enum USER_GENDER {
  MALE = 3,
  FEMALE = 4,
  OTHER = 5
}
